/**
 * CurrencyViewToggle — toggle between transaction-currency and base-currency views.
 */

import { cn } from '@elsapiens/utils'

export interface CurrencyViewToggleProps {
  view: 'transaction' | 'base'
  onChange: (view: 'transaction' | 'base') => void
  baseCurrency: string
}

export function CurrencyViewToggle({ view, onChange, baseCurrency }: CurrencyViewToggleProps): JSX.Element {
  return (
    <div className="flex items-center gap-2 text-sm">
      <span className="text-foreground-secondary">View in:</span>
      <div className="inline-flex rounded-md border border-border bg-muted overflow-hidden">
        <button
          className={cn(
            'px-3 py-1.5 text-sm font-medium transition-colors',
            view === 'transaction'
              ? 'bg-primary-solid text-primary-foreground'
              : 'text-foreground-secondary hover:text-foreground hover:bg-accent',
          )}
          type="button"
          onClick={() => onChange('transaction')}
        >
          Transaction
        </button>
        <button
          className={cn(
            'px-3 py-1.5 text-sm font-medium transition-colors border-l border-border',
            view === 'base'
              ? 'bg-primary-solid text-primary-foreground'
              : 'text-foreground-secondary hover:text-foreground hover:bg-accent',
          )}
          type="button"
          onClick={() => onChange('base')}
        >
          Base ({baseCurrency})
        </button>
      </div>
    </div>
  )
}
